import { createTheme, makeStyles } from '@material-ui/core/styles';
import themeSet from 'consts/theme';

const lightTheme = createTheme({
  ...themeSet.light,
  overrides: {
    MuiButton: {
      textPrimary: {
        color: `${themeSet.light.palette.black}`,
        border: `1px solid ${themeSet.light.palette.white}`,
        boxShadow: `0 0 5px ${themeSet.light.palette.white}`,
        backgroundColor: themeSet.light.palette.green,
        borderRadius: 5,
        padding: 5,
        transition: 'color 0.25s',
        '&:hover': {
          color: `${themeSet.light.palette.white}`,
          backgroundColor: themeSet.light.palette.green,
        },
      },
    },
    MuiGrid: {
      item: {
        textAlign: 'center',
      },
    },
    MuiPickersClock: {
      pin: {
        backgroundColor: themeSet.light.palette.green,
      },
    },
    MuiPickersClockNumber: {
      clockNumber: {
        color: themeSet.light.palette.black,
      },
      clockNumberSelected: {
        color: themeSet.light.palette.white,
      },
    },
    MuiPickersClockPointer: {
      noPoint: {
        backgroundColor: themeSet.light.palette.green,
      },
      pointer: {
        backgroundColor: themeSet.light.palette.green,
      },
      thumb: {
        borderColor: themeSet.light.palette.green,
        backgroundColor: themeSet.light.palette.black,
      },
    },
    MuiPickersDay: {
      current: {
        color: themeSet.light.palette.black,
        boxShadow: `0 0 5px ${themeSet.light.palette.white}`,
      },
      daySelected: {
        color: themeSet.light.palette.black,
        backgroundColor: themeSet.light.palette.green,
      },
    },
    MuiPickerDTToolbar: {
      separator: {
        margin: 'none',
      },
      toolbar: {
        paddingLeft: '0px',
        paddingRight: '0px',
      },
    },
    MuiPickersToolbarText: {
      toolbarBtnSelected: {
        color: themeSet.light.palette.white,
        textShadow: `0px 0px 2px ${themeSet.light.palette.white}`,
      },
      toolbarTxt: {
        color: themeSet.light.palette.white,
        fontSize: '1rem',
      },
    },
    MuiPickersYear: {
      yearSelected: {
        fontSize: '1.2rem',
        fontWeight: 600,
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: themeSet.light.palette.darkGrey,
      },
    },
    MuiPickerDTTabs: {
      tabs: {
        backgroundColor: themeSet.light.palette.darkGrey,
      },
    },
    PrivateTabIndicator: {
      colorSecondary: {
        backgroundColor: themeSet.light.palette.green,
      },
    },
  },
});

const darkTheme = createTheme({
  ...themeSet.dark,
  overrides: {
    MuiButton: {
      textPrimary: {
        color: `${themeSet.dark.palette.black}`,
        border: `1px solid ${themeSet.dark.palette.white}`,
        boxShadow: `0 0 5px ${themeSet.dark.palette.white}`,
        backgroundColor: themeSet.dark.palette.green,
        borderRadius: 5,
        padding: 5,
        transition: 'color 0.25s',
        '&:hover': {
          color: `${themeSet.dark.palette.white}`,
          backgroundColor: themeSet.dark.palette.green,
        },
      },
    },
    MuiGrid: {
      item: {
        textAlign: 'center',
      },
    },
    MuiPickersClock: {
      pin: {
        backgroundColor: themeSet.dark.palette.green,
      },
    },
    MuiPickersClockNumber: {
      clockNumber: {
        color: themeSet.dark.palette.green,
      },
      clockNumberSelected: {
        color: themeSet.dark.palette.black,
      },
    },
    MuiPickersClockPointer: {
      noPoint: {
        backgroundColor: themeSet.dark.palette.green,
      },
      pointer: {
        backgroundColor: themeSet.dark.palette.green,
      },
      thumb: {
        borderColor: themeSet.dark.palette.green,
        backgroundColor: themeSet.light.palette.black,
      },
    },
    MuiPickersDay: {
      day: {
        color: themeSet.dark.palette.white,
      },
      current: {
        color: themeSet.light.palette.white,
        boxShadow: `0 0 5px ${themeSet.light.palette.black}`,
      },
      daySelected: {
        color: themeSet.dark.palette.green,
        backgroundColor: themeSet.dark.palette.black,
      },
    },
    MuiPickerDTTabs: {
      tabs: {
        backgroundColor: themeSet.dark.palette.lightGrey,
      },
    },
    MuiPickerDTToolbar: {
      separator: {
        margin: 'none',
      },
      toolbar: {
        paddingLeft: '0px',
        paddingRight: '0px',
      },
    },
    MuiPickersSlideTransition: {
      transitionContainer: {
        color: `${themeSet.dark.palette.sideBarBackgroundColor} !important`,
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: themeSet.dark.palette.lightGrey,
      },
    },
    MuiPickersToolbarText: {
      toolbarBtnSelected: {
        color: themeSet.light.palette.white,
        textShadow: `1px 1px 2px ${themeSet.dark.palette.primary.main}, 0 0 25px ${themeSet.dark.palette.primary.main}, 0 0 5px ${themeSet.light.palette.white}`,
      },
      toolbarTxt: {
        color: themeSet.dark.palette.white,
        fontSize: '1rem',
      },
    },
    MuiPickersYear: {
      root: {
        color: themeSet.dark.palette.white,
      },
      yearSelected: {
        color: themeSet.dark.palette.primary.main,
        fontSize: '1.2rem',
        fontWeight: 600,
      },
    },
    MuiPickersYearSelection: {
      container: {
        backgroundColor: themeSet.dark.palette.secondary.main,
      },
    },
    PrivateTabIndicator: {
      colorSecondary: {
        backgroundColor: themeSet.dark.palette.green,
      },
    },
  },
});

const useStyles = makeStyles(theme => ({
  TimePicker: {
    '&__label-utc-info': {
      color: 'red !important',
      fontWeight: 'bold',
    },
    '&__label': {
      '&__icon': {
        [theme.breakpoints.down(1400)]: {
          height: 15,
          width: 15,
        },
      },
      '&__info': {
        textShadow: `0 0 5px ${theme.palette.white}`,
        '&--help': {
          backgroundColor: theme.palette.error.main,
          borderRadius: 5,
          color: `${theme.palette.white} !important`,
          textAlign: 'center',
        },
      },
      '&--color': {
        color: theme.palette.text.primary,
      },
    },
    '&__underline': {
      '&--border-bottom': {
        '&::before': {
          // borderBottom: `1px solid ${theme.palette.text.primary}`,
        },
      },
    },
    '&--color': {
      color: theme.palette.text.primary,
    },
  },
}));

export { darkTheme, lightTheme, useStyles };
